import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { Helper } from '../common/helpers/Helper';
import { Controller } from '../common/Controller';
import { Divider } from '@material-ui/core';
import { AppTheme } from '../styles/AppTheme';

export class ClientPlaces extends Component {
  constructor(props) {
    super(props);
    this.slug = Controller.get().userMgrV2().getMyOrgId()
    this.state = {
      items: [],
      fetchState: ApiHelperV2.State.LOADING
    }
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    const thisObj = this;
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['placesByOrgId'],{orgId: this.slug}) },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          items: results,
          fetchState: ApiHelperV2.State.READY
        })
      }.bind(this))
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          <p className={css(Styles.headerContainer)}>Places</p>
          <Grid container>
            {this.state.items.map(item => {
              return (
                <Grid item xs={6} sm={3} className={css(Styles.titleContainer)}>
                  <Link to={{ pathname: '/places/' + item._id, state:  {item : item} }}
                    className={css(Styles.link,Styles.linkHeader)}>
                    <Icon className={css(Styles.titleIcon)} color='secondary'>
                    business
                    </Icon>
                    <p className={css(Styles.titleTitle)}>{item.name}</p>
                  </Link>
                  <div className={css(Styles.divider)}>
                    <Divider />
                  </div>
                  <div className={css(Styles.titleInnerContainer)}>
                    <Link to={{ pathname: '/places/' + item._id + '/cams', state:  {item : item} }}
                      className={css(Styles.link)}>
                      <div>
                        <p className={css(Styles.titleReport)}>LIVE STREAMS</p>
                      </div>
                    </Link>
                    <Link to={{ pathname: '/reports/' + item._id, state:  {item : item} }}
                      className={css(Styles.link)}>
                      <div>
                        <p className={css(Styles.titleReport,Styles.titleReportSecond)}>VIEW REPORTS</p>
                      </div>
                    </Link>
                  </div>
                </Grid>
              )
            })}
          </Grid>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '95%',
  },
  headerContainer: {
    fontSize: 25,
    fontWeight: 'bold',
    marginTop: 0,
  },
  titleContainer: {
    paddingRight: 8,
    paddingBottom: 10,
    display: 'flex',
    flexDirection: 'column'
  },
  titleIcon: {
    fontSize: 30
  },
  titleTitle: {
    marginTop: 5,
    marginBottom: 5,
    fontSize: 22,
    fontWeight: 'bold'
  },
  titleInnerContainer: {
    display: 'flex',
    padding: 20,
    paddingBottom: 10,
    paddingTop: 10,
    backgroundColor:AppTheme.secondaryBg,
  },
  linkHeader: {
    padding: 20
  },
  link: {
    textDecoration: 'none',
    color: 'black',
    backgroundColor:AppTheme.secondaryBg,
    flex: 1
  },
  titleReport: {
    display: 'flex',
    marginTop: 0,
    marginBottom: 5,
    fontSize: 13,
    fontWeight: 'bold',
    ':hover' : {
      color: '#ff4081'
    }
  },
  titleReportSecond: {
    justifyContent: 'flex-end',
  },
  divider: {
    backgroundColor: 'white',
    // paddingRight: 20,
    // paddingLeft: 20,
  },
})



// WEBPACK FOOTER //
// ./src/screens/ClientPlaces.js